import React, { useState, useEffect, useRef, useMemo } from "react";

import {Form,ProgressBar} from "react-bootstrap"
import { base, s3base } from "api.js";
import Sound from 'react-sound';
import "components/custom.css";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns";
import SelectVoiceDropDown from "components/PracticeMaterial/SelectVoiceDropDown.jsx";
// import TagIcon1 from "assets/images/images_new/tag1.svg";
import TimeUp from "components/PracticeMaterial/PopUps/TimeUp";
import { useCallback } from "react";

const IDEAL_TIME = 60; // SECONDS.

const Dictation = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  // const [isBlocked, setIsBlocked] = useState(false);
  // const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [content, setContent] = useState('');
  const [soundPer, setSoundPer] = useState(0);
  const [volume, setVolume] = useState(90);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [resultObj, setResultObj] = useState({});
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [questionAudio, setQuestionAudio] = useState(null);
  const [defaultSelectedVoice, setDefaultSelectedVoice] = useState(null);
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);
  const [audioRetryCount, setAudioRetryCount] = useState(0);
  const [playStatus, setPlayStatus] = useState(Sound.status.STOPPED);
  const [inputRows, setInputRows] = useState(1);
  const [scrollHeight, setScrollHeight] = useState(0);
  const [idealTime, setIdealTime] = useState(IDEAL_TIME);
  const [idealTimeInterval, setIdealTimeInterval] = useState(null);
  const [idealTimeExceed, setIdealTimeExceed] = useState(false);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);
  const idealTimeIntervalRef = useRef(null);

    const { data, resultMode, answer, showResponse } = props;

  const selectAndTryAudio = useCallback((index) => {
    const { question_audios } = props.data;
    if (question_audios && question_audios.length > 0 && index < question_audios.length) {
      const selected = question_audios[index];
      setQuestionAudio(`${s3base}/${selected.value}`);
      setDefaultSelectedVoice(selected.label);
      setCurrentAudioIndex(index);
    }
  }, [props.data]);

  const handleAudioError = useCallback((errorCode, description) => {
    console.log("Got the error", errorCode, description);
    const { question_audios, media_link } = props.data;
    
    if (!question_audios || question_audios.length === 0) {
      console.error("No alternative audio available, using media_link");
      setQuestionAudio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      return;
    }

    if (audioRetryCount >= question_audios.length) {
      console.error("All audios failed, falling back to media_link");
      setQuestionAudio(`${s3base}${media_link}`);
      setCurrentAudioIndex(null);
      setSoundKey(prevKey => prevKey + 1);
      setAudioRetryCount(0);
      return;
    }

    const nextIndex = (currentAudioIndex + 1) % question_audios.length;
    setAudioRetryCount(prevCount => prevCount + 1);
    setSoundKey(prevKey => prevKey + 1);
    
    setTimeout(() => {
      selectAndTryAudio(nextIndex);
    }, 100);
  }, [props.data, currentAudioIndex, audioRetryCount, selectAndTryAudio]);

  // Timer function
  const timer = useCallback(() => {
    setSecondCount((prevCount) => {
      if (prevCount === 1) {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
        setPlayStatus(Sound.status.PLAYING);
        return 0;
      } else {
        return prevCount - 1;
      }
    });
  },[])

  // Timer record function
  const timerRecord = () => {
    setRecordCount((prevCount) => {
      if (prevCount === 40) {
        if (recordIdRef.current) {
          clearInterval(recordIdRef.current);
        }
        stopTest();
        return prevCount;
      }
      return prevCount + 1;
    });
  };

  useEffect(() => {
    if (answer && idealTimeIntervalRef.current) {
      clearInterval(idealTimeIntervalRef.current);
      idealTimeIntervalRef.current = null;
    }
  }, [answer]);

  // Count down to ideal time
  const countDownToIdealTime = () => {
    if (props.answer) {
      if (idealTimeIntervalRef.current) {
        clearInterval(idealTimeIntervalRef.current);
      }
    } else {
      setIdealTime((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          if (idealTimeIntervalRef.current) {
            clearInterval(idealTimeIntervalRef.current);
          }
          setIdealTimeExceed(true);
          return 0;
        }
      });
    }
  };
  
  // Initial mount effect
  useEffect(() => {
    if (!props.answer) {
      // select audio.
      let question_audio = null;
      let defaultVoice = null;
      if ('question_audios' in props.data && props.data.question_audios.length > 0) {
        let x = parseInt(Math.random() * 6);

        const { question_audios } = props.data;
        question_audio = `${s3base}/${question_audios[x].value}`;
        defaultVoice = question_audios[x].label;
        setCurrentAudioIndex(x);
        setAudioRetryCount(0);
      } else {
        const { media_link } = props.data;
        question_audio = `${s3base}${media_link}`;
      }

      setQuestionAudio(question_audio);
      setDefaultSelectedVoice(defaultVoice);

      // start countdown.
      const idealInterval = setInterval(countDownToIdealTime, 1000);
      idealTimeIntervalRef.current = idealInterval;
      setIdealTimeInterval(idealInterval);

      const interval = setInterval(timer, 1000);
      intervalIdRef.current = interval;
      setIntervalId(interval);

      props.updateQuestionAudioUrlInPractice(question_audio);
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
      if (idealTimeIntervalRef.current) {
        clearInterval(idealTimeIntervalRef.current);
      }
    };
  }, []);

  // Effect to handle props changes (replaces getDerivedStateFromProps)
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
        if (recordIdRef.current) {
          clearInterval(recordIdRef.current);
        }

        let question_audio = null;
        let defaultVoice = null;
        if ('question_audios' in props.data && props.data.question_audios.length > 0) {
          let x = parseInt(Math.random() * 6);

          const { question_audios } = props.data;
          question_audio = `${s3base}/${question_audios[x].value}`;
          defaultVoice = question_audios[x].label;
          setCurrentAudioIndex(x);
          setAudioRetryCount(0);
        } else {
          const { media_link } = props.data;
          question_audio = `${s3base}${media_link}`;
        }

        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setSoundStatus(true);
        setContent('');
        setQuestionAudio(question_audio);
        setDefaultSelectedVoice(defaultVoice);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart, questionId]);

  // Effect to handle reset
  useEffect(() => {
    if (reset) {
      const interval = setInterval(timer, 1000);
      intervalIdRef.current = interval;
      setIntervalId(interval);
      setReset(false);
    }
  }, [reset]);

  const stopTest = () => {
    props.nextQuestion(resultObj);
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
  };

  const changeRange = (e) => {
    setVolume(parseInt(e.target.value));
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    setPlayStatus(Sound.status.STOPPED);
    props.soundChecked();
    props.showResult();
     if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  // const cutToClipboard = () => {
  //   document.execCommand("cut");
  // };

  // const pasteToClipboard = async () => {
  //   alert("Press Ctrl+v for paste text");
  // };

  const changePlaybackSpeed = (speed) => {
    setSoundKey((prevKey) => prevKey + 1);
    setPlaybackSpeed(speed);
  };

  const handleTextareaSize = (e) => {
    const textarea = e.target;

    const maxHeight = 241;

    textarea.style.height = "auto";

    if (textarea.scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + "px";
      textarea.style.overflowY = "auto"; // show scrollbar
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden"; // hide scrollbar
    }
  };

  const chaneText = (e) => {
    let { name, value } = e.target;
    const hasContent = value.trim().length > 0;
props.submit({ 'answer': value, 'correct': '' }, hasContent);
    setContent(value);
    setResultObj({ 'answer': value, 'correct': '' });
  };

  const updateCorrect = () => {
    props.submit({ 'answer': '', 'correct': '' });
    setCorrectFlag(false);
    setResultObj({ 'answer': '', 'correct': '' });
  };

  const skip = () => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }
    setSecondCount(0);
    setPlayStatus(Sound.status.PLAYING);
  };

  const changeAudio = (selected) => {
    const { question_audios } = props.data;
    const selected_audio = question_audios.filter((audio, i) => {
      return audio.label === selected.label;
    });

    setQuestionAudio(`${s3base}/${selected_audio[0].value}`);
    setPlayStatus(Sound.status.PLAYING);
  };

  const onLoad = (obj) => {
    // console.log(obj)
  };

  const playingQuestionSectionLabel = () => {
    let status = '';
     if (props.answer) {
    return 'Question audio finished.';
  }
    if (!isRecording) {
      if (secondCount !== 0 && soundStatus === true) {
        status = `Beginning in ${secondCount} seconds`;
      } else if (secondCount === 0 && soundStatus) {
        status = 'Playing question audio...';
      } else {
        status = 'Question audio finished.';
      }
    } else {
      status = 'Question audio finished.';
    }
    return status;
  };

  const showSkipAudioWaitButton = () => {
    const { testMode } = props;

    let button = false;
    if (!testMode && secondCount !== 0 && blobURL === '' && !isRecording) {
      button = true;
    }

    return button;
  };

  const playAudio = () => {
    const { data, resultMode } = props;

    let audio = false;
    if (data && !resultMode && soundStatus && secondCount === 0) {
      audio = true;
    }

    return audio;
  };

  const wordCount = () => {
    return content === "" ? 0 : content.trim().split(/\s+/).length;
  };

  const idealTimeExceedToggle = () => {
    setIdealTimeExceed(!idealTimeExceed);
  };

  // let questionText = "";
  const questionText = useMemo(() => {
  return props.data?.question || "";
}, [props.data?.question]);

  // if (props.restart) {
  //   props.restartQue();
  // }

  useEffect(() => {
  if (props.restart) {
    props.restartQue();
  }
}, [props.restart, props.restartQue]);

  // if (props.stopRecording) {
  //   stopTest();
  // }
  // if (props.data) {
  //   questionText = props.data.question;
  //   if (correctFlag) {
  //     updateCorrect();
  //   }
  // }

  useEffect(() => {
  if (props.data && correctFlag) {
    updateCorrect();
  }
}, [props.data?.id, correctFlag]);

  return (
    <>
      {playAudio() && questionAudio &&
        <Sound
          autoLoad={true}
          url={questionAudio}
          playStatus={answer || !props.soundStatusMain ? Sound.status.STOPPED : Sound.status.PLAYING}
          onPlaying={handleSongPlaying}
          volume={volume}
          onFinishedPlaying={handleSongFinishedPlaying}
          onError={handleAudioError}
          playbackRate={playbackSpeed}
          key={soundKey}
          onLoading={onLoad}
        />
      }

      <div className="pmw-tabs-section d-flex align-items-start justify-content-center pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible mx-0">
        {/* <div className="recorded-section h-100 width-25" width-50></div> */}
        <div className="recorded-section h-100 ">
          <div className="recorded-content">
            <div className="row">
              <div className="col-12">
                <ul className="recorded-list">
                  <li>Status:</li>
                  <li>{playingQuestionSectionLabel()}</li>
                </ul>
              </div>

                {/* <div className="col-4"> <span className="volume-label">Volume</span> </div> */}
            </div>
            <div className="recorded-audio-wrapper">
              <div className="mt-3 clearfix">

                <div className="row">
                  <div className="col-10 col-sm-11">
                    <ProgressBar now={soundPer} striped />
                  </div>
                  <div className="col-1">
                    <div className="volume-control-wrapper">
                      <span className="volume-icon">
                        <i className="fa fa-volume-up" aria-hidden="true"></i>
                      </span>
                      <div className="re-volume-wrapper-horizontal">
                        <input
                          type="range"
                          placeholder="Volume"
                          className="volume-control"
                          min="0"
                          max="100"
                          step="1"
                          defaultValue={volume}
                          onInput={changeRange}
                          style={{
                            "--progress": `${(volume / 100) * 100}%`,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* <div className="col-12 mt-2">
                    {defaultSelectedVoice !== null &&
                      <div className="pull-left visibility-visible">
                        <SelectVoiceDropDown
                          voices={props.voices}
                          selected={defaultSelectedVoice}
                          changeAudio={changeAudio}
                        />
                      </div>
                    }

                    <div className="ml-5 pull-left">
                      <PlaybackSpeedBtns
                         answer={props.answer}
                        sound = {soundStatus}
                        changePlaybackSpeed={changePlaybackSpeed}
                        playbackSpeed={playbackSpeed}
                      />
                    </div>

                    {showSkipAudioWaitButton() && !props.answer &&
                      <div className="btn-outer pull-right visibility-visible">
                        <a
                          href="javascript:void(0)"
                          className="outline-btn skip-btn-new text-center"
                          onClick={skip}
                        >Start Audio</a>
                      </div>
                    }
                  </div> */}
                  <div className="col-12 mt-2">
                    <div className="d-flex align-items-center justify-content-between gap-3">
                      <div className="d-flex gap-2">
                        <div className="d-flex align-items-start">
                          <PlaybackSpeedBtns
                            answer={props.answer}
                            sound={soundStatus}
                            changePlaybackSpeed={changePlaybackSpeed}
                            playbackSpeed={playbackSpeed}
                          />
                        </div>
                      
                        {defaultSelectedVoice !== null &&(
                          <div className="d-flex align-items-center">
                            <SelectVoiceDropDown
                              answer = {answer}
                              sound = {soundStatus}
                              voices={props.voices}
                              selected={defaultSelectedVoice}
                              changeAudio={changeAudio}
                            />
                          </div>
                        )}
                      </div>

                      {showSkipAudioWaitButton() && !props.answer && (
                        <div>
                          <button
                            className="outline-btn skip-btn-new"
                            onClick={skip}
                          >
                            Start Audio
                          </button>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!answer &&
        <div className="editor-wrapper-section custom-box mx-0">
          <div className="editor-wrapper">
            <div className="editor__toolbar">
              <button className="toolbar__button"></button>
            </div>
            <div className="editor__input">

              <Form.Control
                as="textarea"
                className="writing-textarea"
                onCopy={copyToClipboard}
                autoCorrect="false"
                spellCheck="false"
                name="content"
                onChange={(e) => { chaneText(e) }}
                onKeyUp={handleTextareaSize}
                value={content}
                placeholder="Write your response here"
              />

              {/*!answer ? (
                <Input
                  type="textarea"
                  className="writing-textarea"
                  onCopy={this.copyFunc}
                  autoCorrect="false"
                  spellCheck="false"
                  name="content"
                  onChange={(e) => { this.chaneText(e)}}
                  onKeyUp={this.handleTextareaSize}
                  value={this.state.content}
                  placeholder="Write your response here"
                />
              ) : (
                <div style={{
                  whiteSpace: 'pre-line'
                }}>{this.state.content}</div>
              )*/}
            </div>
          </div>

          <div className="mt-3 clearfix">
            <div className="word-count pull-right">
              <span>Total word count:</span> {wordCount()}
            </div>
          </div>
        </div>
      }
      {!answer && 
      <TimeUp
        isOpen={idealTimeExceed}
        toggle={idealTimeExceedToggle}
        title="Time Alert"
        message="You spent 1 minute on [Write from Dictation], which is the recommended time. Click Submit Now to submit your response, or click on Cross to ignore."
        buttonLabel="Submit Now"
        showResponse={showResponse}
          allowClose={true}
        submitDisable={props.submitDisable}
      />
      }
      
    </>
  );
};

export default Dictation;